import { Route, Routes } from 'react-router';
import { plannedShopping } from '@tahi/core';
import { registerPlannedSpendingProvider } from '../../data/commitments';
import { seedShoppingDefaults } from '../../data/commands/shopping';
import { onModuleUsable } from '../../data/moduleHooks';
import { listOpenItems } from '../../data/repos/shopping';
import { registerTile } from '../../tiles/registry';
import { registerWebModule } from '../registry';
import { ShoppingIcon } from './ShoppingIcon';
import { copy } from './copy';
import { EditItemRoute } from './screens/EditItemRoute';
import { ItemPriceScreen } from './screens/ItemPriceScreen';
import { PastTripsScreen } from './screens/PastTripsScreen';
import { PricesScreen } from './screens/PricesScreen';
import { ShoppingListScreen } from './screens/ShoppingListScreen';
import { TripDetailScreen } from './screens/TripDetailScreen';
import { LastTripTile } from './tiles/LastTripTile';
import { ListTile } from './tiles/ListTile';

/** Mounted by v0.1c's ModuleRoute at /m/shopping/*, so these paths are relative. */
function ShoppingScreen() {
  return (
    <Routes>
      <Route index element={<ShoppingListScreen />} />
      <Route path="items/:id" element={<EditItemRoute />} />
      <Route path="trips" element={<PastTripsScreen />} />
      <Route path="trips/:id" element={<TripDetailScreen />} />
      <Route path="prices" element={<PricesScreen />} />
      <Route path="prices/:key" element={<ItemPriceScreen />} />
    </Routes>
  );
}

registerWebModule({
  id: 'shopping',
  navLabel: copy.navLabel,
  Icon: ShoppingIcon,
  Screen: ShoppingScreen,
});

registerTile({
  type: 'shopping.list',
  moduleId: 'shopping',
  title: copy.listTile,
  sizes: ['wide', 'small'],
  defaultSize: 'wide',
  defaultOnToday: true,
  Component: ListTile,
});

registerTile({
  type: 'shopping.last-trip',
  moduleId: 'shopping',
  title: copy.lastTripTile,
  sizes: ['small', 'wide'],
  defaultSize: 'small',
  Component: LastTripTile,
});

// Budget's "what's left" shows open items with estimates beside the number, never subtracted (spec §6).
registerPlannedSpendingProvider({
  id: 'shopping',
  moduleId: 'shopping',
  tables: ['shopping_items'],
  load: async (db, userId) => plannedShopping(await listOpenItems(db, userId)),
});

// Seeds the Groceries category whenever Shopping becomes usable (toggle, forced_on, app start).
onModuleUsable('shopping', seedShoppingDefaults);
